import type { Variable } from '@core/entities/Variable';
import type { VariableInput } from '@core/repositories/CollectionRepository';
import type { GlobalVariableRepository } from '@core/repositories/GlobalVariableRepository';
import { httpClient } from '@infrastructure/http/httpClient';
import { toAppError } from '@infrastructure/http/errorMapper';
import {
  toVariable,
  toVariableInputPayload,
  type VariableResponse,
} from '@infrastructure/mappers/toVariable';

export class GlobalVariableRepositoryImpl implements GlobalVariableRepository {
  async list(workspaceId: string): Promise<Variable[]> {
    try {
      const response = await httpClient.get<{ data: VariableResponse[] }>(
        `/workspaces/${workspaceId}/globals`,
      );
      return response.data.data.map(toVariable);
    } catch (error) {
      throw toAppError(error);
    }
  }

  async sync(workspaceId: string, variables: VariableInput[]): Promise<Variable[]> {
    try {
      const response = await httpClient.put<{ data: VariableResponse[] }>(
        `/workspaces/${workspaceId}/globals`,
        { variables: variables.map(toVariableInputPayload) },
      );
      return response.data.data.map(toVariable);
    } catch (error) {
      throw toAppError(error);
    }
  }
}
